export interface Product {
  id: string;
  title: string;
  description: string;
  category: string;
  categorySlug: string;
  price: number;
  rating: number;
  reviews: number;
  sales: number;
  seller: string;
  image: string;
  badge?: '인기' | '신상품';
  usageDescription?: string;
  usageImageUrl?: string;
  usageVideoUrl?: string;
}

export const products: Product[] = [];
